import { produce } from 'immer';
import { create } from 'zustand';
import { UserActions, UserState, UserStore } from '~/types';

const initialUserState = (): UserState => ({
  email: '',
  password: '',
  name: '',
  nickname: '',
  birth_date: '',
  gender: '',
  language: '',
  privacy_agree: false,
  avatar_agree: false,
  marketing_agree: false,
  timezone_iana: '',
});

const updateState = <T extends object>(state: T, updates: Partial<T>) => {
  Object.keys(updates).forEach((key) => {
    const typedKey = key as keyof T;
    if (updates[typedKey] !== undefined) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      state[typedKey] = updates[typedKey]!;
    }
  });
};

const userActions = (
  set: (
    partial:
      | UserStore
      | Partial<UserStore>
      | ((state: UserStore) => UserStore | Partial<UserStore>),
    replace?: boolean,
  ) => void,
): UserActions => ({
  setUser: (updates) => {
    set(
      produce((state: UserState) => {
        updateState(state, updates);
      }) as (state: UserStore) => UserStore,
    );
  },
  resetUserData: () => {
    set(() => ({
      ...initialUserState(),
      ...userActions(set),
    }));
  },
});

const useUserStore = create<UserStore>((set) => ({
  ...initialUserState(),
  ...userActions(set),
}));

export default useUserStore;
